import Layout from "../../components/Layout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp, faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import SwitchToggle from "../../components/Utilities/SwitchToggle";
import {Editor} from "@tinymce/tinymce-react";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState, useCallback} from "react";
import ApiRoute, {uploadUrl} from "../../helper/api";
import CustomMultiSelect from "../../components/Utilities/CustomMultiSelect";
import PrePaymentRule from "../../components/Payment/PrePaymentRule";
import ShopSelect from "../../components/Shop/ShopSelect";
import {toast} from "react-toastify";

export default function EditMethod() {

    const search = window.location.search;
    const params = new URLSearchParams(search);

    const [editor, setEditor] = useState(null);
    const [data, setData] = useState(null);
    const [content, setContent] = useState('');
    const [links, setLinks] = useState([]);
    const editorRef = useRef(null);
    const [shopEditors, setShopEditors] = useState({});
    const [selectedShop, setSelectedShop] = useState('');
    const [shopDetails, setShopDetails] = useState([]);

    useEffect(() => {
        getData()
    }, []);

    useEffect(() => {
        if (data){
            setContent(data.desc)
            setShopDetails(data?.shop_details ?? [])
        }
    }, [data]);

    async function getData(){
        const response = await ApiRoute.payment.method.single.fn(params.get('id'))
        setData(response.results)
    }

    const addShopDetail = () => {
        if (!selectedShop) {
            toast.error("لطفا فروشگاه را انتخاب کنید");
            return;
        }
        
        const newShopDetail = {
            shop_id: selectedShop,
            description: ""
        };
        
        setShopDetails([...shopDetails, newShopDetail]);
        setData({
            ...data,
            shop_details: [...shopDetails, newShopDetail]
        });
        setSelectedShop('');
    };

    const removeShopDetail = (index) => {
        const newShopDetails = shopDetails.filter((_, i) => i !== index);
        setShopDetails(newShopDetails);
        setData({
            ...data,
            shop_details: newShopDetails
        });
    };


    const updateShopDescription = (index, content) => {
        shopDetails[index].description = content
    };

    async function handleSubmit() {
        data.desc = editor.getContent();
        data.shop_details = shopDetails;
        setData(data);
        await ApiRoute.payment.method.update.fn(data._id, data);
    }

     return (
        <Layout>
            {data && <div>
                <div className="page-title mb-3"><span
                    className="inline-block bg-white pl-3">ویرایش {data.title}</span>
                </div>

                <div className="main-content mx-auto p-5 mt-6">
                    <span className="block text-right text-sm p-2">توضیحات</span>
                    <Editor
                        tinymceScriptSrc='/tinymce/tinymce.min.js'
                        onInit={(evt, editor) => {
                            setEditor(editor);
                            editorRef.current = editor
                        }}
                        onSetContent={ (evt, editor) => setContent(editor.getContent()) }
                        initialValue={content}
                        init={{
                            images_upload_url: uploadUrl,
                            selector: 'textarea#open-source-plugins',
                            plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                            editimage_cors_hosts: ['picsum.photos'],
                            menubar: 'file edit view insert format tools table help',
                            toolbar: "undo redo | accordion accordionremove | blocks fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
                            autosave_ask_before_unload: true,
                            autosave_interval: '30s',
                            autosave_prefix: '{path}{query}-{id}-',
                            autosave_restore_when_empty: false,
                            autosave_retention: '2m',
                            image_advtab: true,
                            rtl_ui:true,
                            directionality : "rtl",
                            rtl: true,
                            importcss_append: true,
                            file_picker_callback: (callback, value, meta) => {
                                /* Provide file and text for the link dialog */
                                if (meta.filetype === 'file') {
                                    callback('https://www.google.com/logos/google.jpg', {text: 'My text'});
                                }

                                /* Provide image and alt text for the image dialog */
                                if (meta.filetype === 'image') {
                                    callback('https://www.google.com/logos/google.jpg', {alt: 'My alt text'});
                                }

                                /* Provide alternative source and posted for the media dialog */
                                if (meta.filetype === 'media') {
                                    callback('movie.mp4', {
                                        source2: 'alt.ogg',
                                        poster: 'https://www.google.com/logos/google.jpg'
                                    });
                                }
                            },
                            templates: [],
                            height: 700,
                            image_caption: true,
                            quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                            noneditable_class: 'mceNonEditable',
                            toolbar_mode: 'sliding',
                            contextmenu: 'link image table',
                            skin: 'oxide',
                            content_css: 'default',
                            content_style: ' @import url(\'https://fonts.googleapis.com/css2?family=Vazirmatn:wght@100;200;300;400;500;600;700;800;900&display=swap\'); body { font-family:"Vazirmatn",Arial,sans-serif; font-size:16px; text-align:right; direction:rtl; } img{ width:100%; height:auto; }'
                        }}
                    />

                    <div className="flex-col flex justify-center mx-auto mt-6 gap-2">
                        <span className="block text-right text-sm">فروشگاه های قابل دسترسی</span>
                        <ShopSelect
                            multiple={true}
                            assignItem={ (v) => {
                                data.available_shops = v.map(shop => shop._id || shop.value)
                            } }
                            value={data?.available_shops}
                        />
                    </div>

                    <div className="mt-8">
                        <h3 className="text-lg font-bold mb-4">جزئیات فروشگاه‌ها</h3>
                        <div className="flex gap-4 mb-4">
                            <div className="w-64">
                                <ShopSelect
                                    assignItem={(v) => {
                                        if(v?._id){
                                            setSelectedShop(v._id);
                                        }else{
                                            setSelectedShop('');
                                        }
                                    }}
                                    multiple={false}
                                />
                            </div>
                            <button 
                                onClick={addShopDetail}
                                className="btn-purple px-4 py-2"
                            >
                                افزودن فروشگاه
                            </button>
                        </div>

                        {shopDetails.map((shop, index) => (
                            <div key={index} className="mb-8 border p-4 rounded">
                                <div className="flex justify-between mb-4">
                                    <h4 className="font-bold">فروشگاه {shop.shop_title ?? shop.shop_id}</h4>
                                    <button 
                                        onClick={() => removeShopDetail(index)}
                                        className="text-red-500"
                                    >
                                        حذف
                                    </button>
                                </div>
                                <Editor
                                    tinymceScriptSrc='/tinymce/tinymce.min.js'
                                    onInit={(evt, editor) => {
                                        const editors = {...shopEditors};
                                        editors[index] = editor;
                                        setShopEditors(editors);
                                    }}
                                    initialValue={shop?.description ?? ''}
                                    onEditorChange={(content) => {
                                        updateShopDescription(index, content)
                                    }}
                                    init={{
                                        images_upload_url: uploadUrl,
                                        selector: 'textarea#open-source-plugins',
                                        plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
                                        editimage_cors_hosts: ['picsum.photos'],
                                        menubar: 'file edit view insert format tools table help',
                                        toolbar: "undo redo | accordion accordionremove | blocks fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl",
                                        autosave_ask_before_unload: true,
                                        autosave_interval: '30s',
                                        autosave_prefix: '{path}{query}-{id}-',
                                        autosave_restore_when_empty: false,
                                        autosave_retention: '2m',
                                        image_advtab: true,
                                        rtl_ui:true,
                                        directionality : "rtl",
                                        rtl: true,
                                        importcss_append: true,
                                        file_picker_callback: (callback, value, meta) => {
                                            if (meta.filetype === 'file') {
                                                callback('https://www.google.com/logos/google.jpg', {text: 'My text'});
                                            }
                                            if (meta.filetype === 'image') {
                                                callback('https://www.google.com/logos/google.jpg', {alt: 'My alt text'});
                                            }
                                            if (meta.filetype === 'media') {
                                                callback('movie.mp4', {
                                                    source2: 'alt.ogg',
                                                    poster: 'https://www.google.com/logos/google.jpg'
                                                });
                                            }
                                        },
                                        templates: [],
                                        height: 300,
                                        image_caption: true,
                                        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                                        noneditable_class: 'mceNonEditable',
                                        toolbar_mode: 'sliding',
                                        contextmenu: 'link image table',
                                        skin: 'oxide',
                                        content_css: 'default',
                                        content_style: `
                                            @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@100;200;300;400;500;600;700;800;900&display=swap');
                                            body {
                                                font-family: "Vazirmatn", Arial, sans-serif;
                                                font-size: 16px;
                                                text-align: right;
                                                direction: rtl;
                                                unicode-bidi: bidi-override;
                                            }
                                            img {
                                                width: 100%;
                                                height: auto;
                                            }
                                            p, div, span {
                                                unicode-bidi: bidi-override;
                                            }
                                        `
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    <PrePaymentRule data={data} setData={setData}/>

                    <div className="flex justify-center mx-auto mt-6 gap-12">
                        <Link to="/payment-methods" className="btn-gray w-36 py-2">لغو</Link>
                        <button onClick={ (e) => {
                            handleSubmit()
                        } } className="btn-green rounded w-36 py-2">ویرایش</button>
                    </div>
                </div>
            </div>}
        </Layout>
    )
}